import styled from "styled-components";
import { H4 } from "@eriksdigital/atomic-ui/components";

export const CategoryTitleH4 = styled(H4)`
  color: #19335e;
`;
